﻿<template>

    <header class="header is-overlay">
        <header_menu></header_menu>
    </header>

    <main class="lg-shell" :style="{ backgroundImage: 'url(' + GetHeroImage() + ')' }">
        <div class="lg-wrap" :class="{ 'is-wide': screen == 'register' }">
            <h1 class="lg-title">{{getLoginTitle()}}</h1>

            <section class="mb-card lg-card">
                <div class="mb-card-body">
                    <div :hidden="Hide_Login()"><agent_login></agent_login></div>
                    <div :hidden="Hide_Select_Consultant()"><select_consultant></select_consultant></div>
                    <div :hidden="screen != 'forgot_password'"><forgot_password_screen></forgot_password_screen></div>
                    <div :hidden="screen != 'register'"><register_screen></register_screen></div>
                </div>
            </section>
        </div>
    </main>

</template>

<script lang="ts" src="./login_screen.ts"></script>
